import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
import CountryTag from "@/components/countryTag/CountryTag.vue";
import LocalizedLink from "@/components/LocalizedLink.vue";

export default {
    name: "SectionDetailHero",
    data() {
        return {
            hoverprev: false,
            hovernext: false
        };
    },
    components: {
        Breadcrumb,
        CountryTag,
        LocalizedLink
    },
    props: {
        keySection: "",
        previousAndNextObj: {prevKey: "", nextKey: "", prevTitle: "", nextTitle: ""},
        activeUrbanEnvironmentOrGeography: "",
        title: "",
        subtitle: "",
        geography: "",
        heroImage: "",
    },
    computed: {},
    mounted() {},
    created: function () {
        // var heroBackgroundImage = this.heroBackgroundImage;
        // $(document).ready(function() {
        //     $(".urban-environment").css("background-image", "url('" + require("@/assets/sectionDetail/hero/urbanEnvironment/" + heroBackgroundImage))
        // });
    },
    methods: {
        goToRoute(sectionKey) {
            this.$emit('goToRoute', sectionKey)
        }
    },
};
